import React from 'react';
import { SearchContentSectionProps } from '../ContentSection';
import IllustrationState from '../../IllustrationState';
import NoData from '../../../../assets/icon/illustrations_no-document.svg';
import { Container, Grid, Group, Image, Stack, Text } from '@mantine/core';
import Button from '../../../elements/Button';
import { formatTitle } from '../../../../utilities/dataFormat';
import LoaderTestimony from '../../../section/TestimonySection/LoaderTestimony';
import TestimonyItem from '../../../section/TestimonySection/TestimonyItem';
import TestimonyCarousel from '../../../section/TestimonySection/TestimonyCarousel';

const TestimonySection: React.FC<SearchContentSectionProps> = ({
  data,
  isSearch,
  querysearch,
  isDetail,
  id,
  title,
  subtitle,
  isCarousel,
  loading: loadingState = false,
  isUmum = false,
  isButtonView
}) => {
  const publishSize = { base: 12, sm: 6, lg: 4, xl: 3 };

  const contentList = data.filter((section) => section.id === id)[0]?.contents;

  return (
    <Container size={'xl'} w={'100%'} px={0}>
      <Stack gap={12}>
        <Group align="center" justify="space-between">
          <Stack gap={0}>
            <Text fz={20} fw={700}>
              {isSearch ? 'Testimony' : title}
            </Text>
            {isSearch ? (
              <Text fz={14} fw={500} c={'gray'}>
                {contentList.length} Results
              </Text>
            ) : (
              <Text fz={14} fw={500} c={'gray'}>
                {subtitle}
              </Text>
            )}
          </Stack>
          {!isDetail && contentList.length > 4 && (
            <Button
              variant="link"
              linkTo={
                isUmum
                  ? `/s/d?type=004&search=${querysearch}`
                  : isSearch
                  ? `/search/detail?type=004&search=${querysearch}`
                  : `/list/${formatTitle(title)}/001/${id}`
              }
            >
              View All
            </Button>
          )}
        </Group>
        {isSearch ? (
          <div>
            <Grid>
              {loadingState && (
                <>
                  {[...Array(4)].map((_, i) => (
                    <Grid.Col key={i} span={'auto'}>
                      <LoaderTestimony />
                    </Grid.Col>
                  ))}
                </>
              )}

              {!loadingState && contentList.length === 0 && (
                <Grid.Col span={12}>
                  <IllustrationState
                    isIlustration={false}
                    Illustration={<Image src={NoData} w={'50%'} />}
                    description="No result found"
                  />
                </Grid.Col>
              )}

              {!loadingState &&
                contentList.length > 0 &&
                contentList.map((content, i) => {
                  return (
                    <Grid.Col key={i} span={publishSize}>
                      <TestimonyItem
                        {...content}
                        title={title}
                        isSearch={isSearch}
                        querysearch={querysearch}
                      />
                    </Grid.Col>
                  );
                })}
            </Grid>
          </div>
        ) : (
          <div>
            <Grid>
              {loadingState && (
                <>
                  {[...Array(4)].map((_, i) => (
                    <Grid.Col key={i} span={'auto'}>
                      <LoaderTestimony />
                    </Grid.Col>
                  ))}
                </>
              )}

              {!loadingState && contentList.length === 0 && (
                <Grid.Col span={12}>
                  <IllustrationState
                    Illustration={<Image src={NoData} w={'50%'} />}
                    description="No data found"
                  />
                </Grid.Col>
              )}

              {!loadingState &&
                contentList.length > 0 &&
                contentList.length <= 8 &&
                contentList.map((content, i) => {
                  return (
                    <Grid.Col key={i} span={publishSize}>
                      <TestimonyItem
                        {...content}
                        title={title}
                        isSearch={isSearch}
                        querysearch={querysearch}
                      />
                    </Grid.Col>
                  );
                })}
            </Grid>

            {!loadingState &&
              contentList.length > 0 &&
              contentList.length > 8 && (
                <TestimonyCarousel
                  isSearch={isSearch}
                  data={contentList}
                  isCarousel={'Y'}
                  title={title}
                />
              )}
          </div>
        )}
      </Stack>
    </Container>
  );
};

export default TestimonySection;
